import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { User } from "../models/user";
import { map } from "rxjs/operators";
import { sha256 } from "js-sha256";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AddExperienceComponent } from "../add-experience/add-experience.component";
import swal from 'sweetalert2';
import { EditExperienceComponent } from "../edit-experience/edit-experience.component";
import { VariablesGlobales } from '../services/globals';
import { DatePipe } from '@angular/common';
import { AuthService } from "../services/auth.service";
import { Router } from '@angular/router';
import { AuthService as TH } from "../services/auth.service";

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-edit-infos',
  templateUrl: './edit-infos.component.html',
  styleUrls: ['./edit-infos.component.css']
})
export class EditInfosComponent implements OnInit {

  /** Champs du formulaire **/
  @Input() _civilite: string;
  @Input() _nom: string;
  @Input() _prenom: string;
  @Input() _mail: string;
  @Input() _mail2: string;
  @Input() _fixe: string;
  @Input() _portable: string;
  @Input() _naissance: Date;
  @Input() _adresse: string;
  @Input() _ville: string;
  @Input() _pays: string;
  @Input() _codepostal: string;
  @Input() _precisezFormation: string;
  @Input() _precisezEtablissement: string;
  @Input() _profil_experience: number;
  @Input() _reseaux: string;
  @Input() _dispo: string;
  @Input() _datedispo: Date;
  @Input() _remuactu: number;
  @Input() _situation: string;
  @Input() _poste: string;
  @Input() _permis: boolean;
  @Input() _vehicule: string;
  @Input() _salaireMin: string;
  @Input() _salaireMax: string;
  @Input('rating') private rating: number;
  @Input('starCount') private starCount: number = 6;
  @Output() ratingUpdated = new EventEmitter();
  /************ ************/


  /** Boolean + Regex Patter **/

  isChecked: boolean = false;
  lastChecked: boolean;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  phoneNumber = "^((\\+91-?)|0)?[0-9]{10}$";
  postalPattern = "^(?:(?:(?:0[1-9]|[1-8]\\d|9[0-5])(?:\\d{3})?)|97[1-8]|98[4-9]|2‌‌[abAB])$"

  /** Id boutton + champ affiché **/

  selectable = true;
  removable = true;
  champOK: boolean;
  public error: string;

  public selected: string = '';
  public lastValue: string = '';

  ratingArr = {};

  idcandidat: string;
  apikey: string

  jsonData: string;

  user: User;
  control: FormGroup;

  formationModel: NiveauFormations[];
  experienceModel: Experiences[];
  languesChips: any[] = [];

  langues: Langues[] = [];
  isChampOK: ChampOk[] = [];

  fonctionName: string[];
  ContratName: string[];
  regionName: string[];
  profilExpTab: ProfilExps[] = [];
  etablissementTab: Etablissement[];
  situations: Situation[];

  region: Region[] = [];
  dispos: Disponibilite[] = [];
  emploiFonction: Fonction[] = [];
  posteContrat: Contrat[] = [];
  profilEtablissement: Etablissement[] = [];
  niveauLangue: NiveauLangues[] = [];

  currentRating = 0;
  hoverRating = 0;

  empForm = new FormGroup({
    skills: new FormControl(this.languesChips, Validators.nullValidator)
  });

  public _consentement: string;

  languesName = new Array();
  experienceName: Experiences[] = [];
  formationName: NiveauFormations[] = [];
  constructor(private authService: TH, public changeDetectorRefs: ChangeDetectorRef, private encdec: EncryptDecryptService, private http: HttpClient, public dialog: MatDialog,
    public param: VariablesGlobales, private _dateFormatPipe: DatePipe, private fb: FormBuilder) {
    this.apikey = localStorage.getItem('apikey');
    this.setInputs();
  }

  onSave(name, value) {
    let data = { Name: name, Value: value, Id: this.idcandidat, ApiKey: localStorage.getItem('apikey') }
    const formData = new FormData();
    formData.append('Name', name);
    if (name == 'can_date_naissance' || name == 'profil_date_dispo')
      formData.append('Value', value.format('DD-MM-YYYY'));
    else if (name == 'langues' || name == 'nivLangue') {
      let infos = [];
      formData.append('Value', JSON.stringify(value));
    }
    else
      formData.append('Value', value);
    formData.append('Id', this.idcandidat);
    formData.append('ApiKey', localStorage.getItem('apikey'));
    this.http.post('https://api.sitederecrutement.com/Home/UpdateCand', formData).subscribe(result => {

    });
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.getInfos();
    this.getInfoCandidate();
    //this.isAffich('mail');
    this.http.get('https://api.sitederecrutement.com/Home/GetConsentement?apikey=' + localStorage.getItem('apikey'), { responseType: 'text' }).subscribe(
      result => {
        const jsonData = this.encdec.getDecrypt(result);
        let jsonObject: any = JSON.parse(jsonData);
        this._consentement = jsonObject.result;

        if (this.user.consentement === false) {
          const dialogRef = this.dialog.open(DialogConsentement, {
            width: '60rem',
            data: {
              consentement: this._consentement,
            },
            panelClass: 'custom-modalbox'
          });

          dialogRef.afterClosed().subscribe(resulta => {
            if (resulta) {
              const userInfo: UserInfo = {
                idcandidat: this.user.idcandidat,
                can_nom: null,
                can_prenom: null,
                can_civilite: null,
                can_mail: null,
                can_mail3: null,
                can_tel_dom: null,
                can_tel_mob: null,
                can_ville: null,
                can_pays: null,
                can_codepostal: null,
                can_adresse1: null,
                can_date_naissance: null,
                profil: null,
                langues: [],
                consentement: true,
                contrats: [],
                regions: [],
                fonctions: [],
                can_handicap: false,
                can_handicap_amenagement: null,
                can_handicap_consequence: null,
              }
              let data = this.encdec.getEncrypt(JSON.stringify(userInfo));
              const formData = new FormData();
              formData.append('datas', data);
              this.http.post('https://api.sitederecrutement.com/Home/updatecandidate?apikey=' + localStorage.getItem('apikey'), formData, { responseType: "text" }).subscribe(
                (result) => {
                  let data = this.encdec.getDecrypt(result);
                  let obj = JSON.parse(data);
                  const user: User = {
                    idcandidat: obj.idcandidat,
                    can_echec_connexion: obj.can_echec_connexion,
                    can_echec_connexion_date: obj.can_echec_connexion_date,
                    can_echec_connexion_heure: obj.can_echec_connexion_heure,
                    can_passe_date: obj.can_passe_date,
                    candidat_api: obj.can_session_api,
                    can_passe_modif: obj.can_passe_modif,
                    photo: obj.photo,
                    consentement: obj.consentement,
                    nom: obj.can_nom,
                    prenom: obj.can_prenom,
                    mail: obj.can_mail,
                    portable: obj.can_tel_mob
                  }
                  localStorage.setItem('currentUser', JSON.stringify(user));
                }
              )
            }
          });
        }

      }
    );
  }

  onRating(id, rating: number) {
    this.ratingArr[id] = rating;
    this.rating = rating;
    return false;
  }

  showIcon(id, index: number) {
    if (this.ratingArr[id] >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }

  setInfos(obj: any) {
    this.experienceName = obj.experiences;
    this.formationName = obj.niveauformations;
    this.langues = obj.langues;
    this.region = obj.regions;
    this.dispos = obj.disponibilites;
    this.emploiFonction = obj.fonctions;
    this.posteContrat = obj.contrats;
    this.profilEtablissement = obj.etablissements;
    this.niveauLangue = obj.niveaulangues;
    this.situations = obj.situations;
  }

  getInfos() {
    this.http.get('https://api.sitederecrutement.com/Home/getinfos?apikey=' + this.apikey, { responseType: "text" }).subscribe(
      (result) => {
        if (result.includes('{Error :')) {
          let json = JSON.parse(result);
          this.error = json.Error;
        }
        else {
          const obj = JSON.parse(this.encdec.getDecrypt(result));
          this.setInfos(obj);
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        //console.log('Request Complete');
      }
    )
  }

  /*************************** EXPERIENCES *****************************/

  openDialogAdd() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-modalbox';
    dialogConfig.width = '70vw';

    const dialogRef = this.dialog.open(AddExperienceComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      () => {
        this.changeDetectorRefs.detectChanges();
        this.getInfoCandidate();
      }
    )
  }

  openDialogEdit(data: ProfilExps) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { ...data };
    dialogConfig.panelClass = 'custom-modalbox';
    dialogConfig.width = '70vw';

    const dialogRef = this.dialog.open(EditExperienceComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      () => {
        this.changeDetectorRefs.detectChanges();
        this.getInfoCandidate();
      }
    )
  }

  onDelete(expId) {
    swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: "Vous ne pourrez pas annuler les modifications !",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Annuler',
      iconColor: 'd ',
      customClass: {
        confirmButton: 'btn btn-rose',
        cancelButton: 'btn btn-rose',
      },
      confirmButtonText: 'Supprimer',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.http.get('https://api.sitederecrutement.com/Home/SupprExp?apikey=' + this.apikey + '&expId=' + expId + '&Idcandidat=' + this.user.idcandidat,
          { responseType: "text" }).subscribe(
            () => {
              swal.fire(
                {
                  title: 'Supprimée',
                  text: 'Votre experience a été supprimée !',
                  icon: 'success',
                  iconColor: 'd ',
                  customClass: {
                    confirmButton: "btn btn-rose",
                  },
                  buttonsStyling: false
                }
              ).then(() => {
                this.changeDetectorRefs.detectChanges();
                this.getInfoCandidate();
              })
            })
      }
    })
  }

  /************************** FIN *********************/

  setInputs() {
    this.http.get('https://api.sitederecrutement.com/Home/GetInputs?apikey=' + this.apikey, { responseType: "text" }).subscribe(
      (result) => {
        const Jsonobj = JSON.parse(this.encdec.getDecrypt(result));
        this.isChampOK = Jsonobj;
      },
      error => {
        console.log(error);
      }
    );
  }

  getIdForTab(id: string) {
    let champ = this.isChampOK.find(x => x.id === id)
    if (champ) {
      return champ.affiche;
    }
    else {
      return false;
    }
  }

  isAffich(id: string) {
    return this.getIdForTab(id);
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  lastDateNais() {
    this._naissance = new Date(this.lastValue);
  }

  lastDatedispo() {
    this._datedispo = new Date(this.lastValue);
  }

  setInputForm(obj: any) {
    this._civilite = obj.can_civilite
    this._nom = obj.can_nom;
    this._prenom = obj.can_prenom;
    this._mail = obj.can_mail;
    this._mail2 = obj.can_mail3;
    this._fixe = obj.can_tel_dom;
    this._portable = obj.can_tel_mob;
    if (obj.can_date_naissance) {
      const spliter = obj.can_date_naissance.split(' ')[0].split('/');
      this._naissance = new Date(+spliter[2], spliter[1] - 1, +spliter[0]);
    }
    this.idcandidat = obj.idcandidat;
    this._nom = obj.can_nom;
    this._adresse = obj.can_adresse1;
    this._ville = obj.can_ville;
    this._pays = obj.can_pays;
    this._codepostal = obj.can_codepostal;
    this._profil_experience = obj.profil.profil_experience;
    this._precisezFormation = obj.profil.profil_precisez_formation;
    this._remuactu = obj.profil.profil_salaire_actuel;
    this._etablissement = obj.profil.profil_etablissement;
    this._etude = obj.profil.profil_etude;
    this._situation = obj.profil.profil_enposte;
    this._poste = obj.profil.profil_titre;
    this._precisezEtablissement = obj.profil.profil_precisez_etablissement;
    this._dispo = obj.profil.profil_dispo;
    if (obj.profil.profil_date_dispo) {
      const spliter = obj.profil.profil_date_dispo.split(' ')[0].split('/');
      this._datedispo = new Date(+spliter[2], spliter[1] - 1, +spliter[0]);
    }
    this.patientCategory.get('skalls').setValue(obj.langues_n);
    //console.log(this.skills);
    this.ContratName = obj.contrats;
    this.regionName = obj.regions;
    this.fonctionName = obj.fonctions;
    this._salaireMin = obj.profil.profil_salaire_inf;
    this._salaireMax = obj.profil.profil_salaire_sup;
    this.isChecked = obj.can_handicap;
    this.description = obj.can_handicap_amenagement;
    this.description2 = obj.can_handicap_consequence;
  }

  patientCategory: FormGroup = new FormGroup({
    skalls: new FormControl()
  });

  get skills() {
    return this.patientCategory.get('skalls').value;
  };

  getInfoCandidate() {
    this.http.get('https://api.sitederecrutement.com/Home/getcandidate?apikey=' + this.apikey + '&login=' + this.user.candidat_api, { responseType: "text" }).subscribe(
      (result) => {
        const obj = JSON.parse(this.encdec.getDecrypt(result));
        this.setInputForm(obj);
        this.profilExpTab = obj.profilExps;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  compareObjects(o1: any, o2: any): boolean {
    //console.log(o1);
    //console.log(o2);
    return o1.Id === o2.Id;
  }

  _etablissement: any;
  _etude: any;

  setProfilData(): Profil {
    const obj: Profil = {
      profil_precisez_formation: this._precisezFormation,
      profil_experience: this._profil_experience,
      profil_dispo: this._dispo,
      profil_date_dispo: this._dateFormatPipe.transform(this._datedispo, 'dd-MM-yyyy'),
      profil_enposte: this._situation,
      profil_salaire_actuel: this._remuactu,
      profil_etablissement: this._etablissement,
      profil_etude: this._etude,
      profil_precisez_etablissement: this._precisezEtablissement,
      profil_titre: this._poste,
      profil_salaire_inf: this._salaireMin,
      profil_salaire_sup: this._salaireMax
    }

    return (obj);
  }

  description: string;
  description2: string;
  handiCheck: boolean;

  setCandidateData(): UserInfo {
    const objProfil = this.setProfilData();
    const userInfo: UserInfo = {
      idcandidat: this.user.idcandidat,
      can_nom: this._nom,
      can_prenom: this._prenom,
      can_civilite: this._civilite,
      can_mail: this._mail,
      can_mail3: this._mail2,
      can_tel_dom: this._fixe,
      can_tel_mob: this._portable,
      can_ville: this._ville,
      can_pays: this._pays,
      can_codepostal: this._codepostal,
      can_adresse1: this._adresse,
      can_date_naissance: this._dateFormatPipe.transform(this._naissance, 'dd-MM-yyyy'),
      profil: objProfil,
      langues: [],
      consentement: true,
      contrats: this.ContratName,
      fonctions: this.fonctionName,
      regions: this.regionName,
      can_handicap: this.isChecked,
      can_handicap_amenagement: this.description2,
      can_handicap_consequence: this.description,
    }

    //const toppings = this.languesChips.value as string[];
    //toppings.forEach((x) => {
    //  let langue: Langue = {
    //    niveau: '',
    //    niveau_anglais: '',
    //    id: '',
    //    id_anglais: ''
    //  };
    //  if (this.ratingArr[x] && this.ratingArr[x] > 1) {
    //    langue.niveau = this.niveauLangue[this.ratingArr[x] - 1]?.niveau;
    //    langue.id = x;
    //    userInfo.langues.push(langue);
    //  }
    //});

    return (userInfo);
  }

  onSubmitField() {
    const userInfo = this.setCandidateData();
    let data = this.encdec.getEncrypt(JSON.stringify(userInfo));
    const formData = new FormData();
    formData.append('datas', data);
    this.http.post('https://api.sitederecrutement.com/Home/updatecandidate?apikey=' + this.apikey, formData, { responseType: "text" }).subscribe(
      (result) => {
        const obj = JSON.parse(this.encdec.getDecrypt(result));
        this.setInputForm(obj);
      }
    )
    this.selected = '';
  }

  onClick(event) {
    this.selected = event.currentTarget.id;
  }

  onClear() {
    this.selected = '';
  }
}

export interface DialogData {
  consentement: string;
}

@Component({
  selector: 'dialog-consentement',
  templateUrl: 'dialog-consentement.html'
})
export class DialogConsentement {

  public controlForm: FormGroup;
  public _consentement: string;

  constructor(public dialogRef: MatDialogRef<DialogConsentement>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public param: VariablesGlobales
    , private authService: AuthService, private router: Router) {
    this.controlForm = new FormGroup({
      consent: new FormControl(false, [
        Validators.requiredTrue
      ])
    });
    this._consentement = data.consentement;
  }

  optionnal() {

  }

  onNoClick(): void {
    this.authService.logout();
    this.router.navigate(['auth']);
    this.dialogRef.close();
  }

  onClick(): void {
    this.dialogRef.close(true);
  }

}

interface Disponibilite {
  iddisponibilite: string;
  disponibilite: string;
}

interface ChampOk {
  id: string;
  affiche: boolean;
}

interface Situation {
  idsituation: number;
  situation: string;
  situation_anglais: string;
}

interface Secteur {
  idsecteur_activite: number;
  secteur_activite: string;
  secteur_activite_anglais: string;
}

interface Experiences {
  idexperience: number;
  experience: string;
  experience_anglais: string;
}

interface NiveauFormations {
  idniveau_formation: number;
  niveau_formation: string;
  niveau_formation_anglais: string;
}

interface Langues {
  idcompetence_langue: number;
  competence_langue_nom: string;
  competence_langue_nom_anglais: string;
}

interface Langue {
  id: string;
  id_anglais: string;
  niveau: string;
  niveau_anglais: string;
}

interface Profil {
  profil_precisez_formation: string;
  profil_experience: number;
  profil_date_dispo: string;
  profil_dispo: string;
  profil_enposte: string;
  profil_etude: string;
  profil_etablissement: string;
  profil_salaire_actuel: number;
  profil_precisez_etablissement: string;
  profil_titre: string;
  profil_salaire_inf: string;
  profil_salaire_sup: string;
}

interface Region {
  idregion: number;
  region: string;
}

interface Contrat {
  idcontrat: number;
  contrat: string;
}

interface Fonction {
  idfonction: number;
  fonction: string;
}

interface Etablissement {
  idetablissement: number;
  etablissement: string;
}

interface NiveauLangues {
  idniveau: number;
  niveau: string;
}

interface ProfilExps {
  idprofil_exp: string;
  profil_exp_debut: string;
  profil_exp_fin: string;
  profil_exp_intitule: string;
  profil_exp_descrip: string;
  //profil_exp_lieu: string;
  //profil_exp_nbre: string;
  profil_exp_societe: string;
  //profil_exp_moisdeb: string;
  //profil_exp_andeb: string;
  //profil_exp_moisfin: string;
  profil_exp_salaire: string;
  //profil_exp_interim: string;
  profil_exp_duree: string;
  profil_exp_fonction: string;
  profil_exp_secteur: string;
  profil_exp_niveau: string;
  profil_exp_comp1: string;
  profil_exp_comp2: string;
  profil_exp_comp3: string;
}

interface UserInfo {
  idcandidat: string;
  can_civilite: string;
  can_prenom: string;
  can_nom: string;
  can_mail: string;
  can_mail3: string;
  can_tel_dom: string;
  can_tel_mob: string;
  can_ville: string;
  can_pays: string;
  can_codepostal: string;
  can_adresse1: string;
  can_date_naissance: string;
  profil: Profil;
  langues: Langue[];
  consentement: boolean;
  contrats: string[];
  regions: string[];
  fonctions: string[];
  can_handicap: boolean;
  can_handicap_consequence: string;
  can_handicap_amenagement: string;
}
